.sportsList {
  overflow-y: scroll;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

.sportsList::-webkit-scrollbar {
  display: none;
}
